// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"2803":"c4b9ff95","5478":"362bafa4"}[chunkId] + ".chunk.js");